(function () {
    // IE fix
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    let navToggle = document.querySelectorAll(
        '.diu-neos-structure-header__mobile .diu-neos-structure-header__molecule-menu-subNavigation'
    );
    if (navToggle.length > 0) {
        navToggle.forEach(function (navItem) {
            navItem.onclick = function () {
                if (this.classList.contains('js-active')) {
                    this.classList.remove('js-active');
                } else {
                    let navOpened = document.querySelectorAll(
                        '.diu-neos-structure-header__mobile-overlay .diu-neos-structure-header__molecule-menu-subNavigation.js-active'
                    );
                    if (navOpened.length > 0) {
                        navOpened.forEach(function (navActive) {
                            navActive.classList.remove('js-active');
                        });
                    }
                    this.classList.add('js-active');
                }
            };
        });
    }
})();
